// extracted by mini-css-extract-plugin
export default {"voice-tag":"VoiceTag_voice-tag__2VH9f","waveform":"VoiceTag_waveform__aAPNX","audio-button":"VoiceTag_audio-button__t38em"};